export default __webpack_public_path__ + "images/a0b02a698b3c261512f8ae55f1b4d233-services-info.svg";